import React from 'react';
import { useTranslation } from "react-i18next";
import "../i18n";

const ResponsibleAI = () => {
    const { t } = useTranslation("ResponsibleAI");

    return (
        <>
            <section>
                <div className="page-bg">
                    <div className="container">
                        <h4>{t("title")}</h4>
                    </div>
                </div>
            </section>

            <section className='information-details ai-compliance'>
                <div className="container">
                    <h6>
                        {t("intro1")} <b>{t("intro2")}</b> {t("intro3")}
                    </h6>

                    <ul>
                        <li>
                            {t("point1.part1")} <b>{t("point1.bold")}</b> {t("point1.part2")}
                        </li>
                        <li>
                            <b>{t("point2.bold")}</b> {t("point2.part2")}
                        </li>
                        <li>
                            {t("point3.part1")} <b>{t("point3.bold1")}</b>, <b>{t("point3.bold2")}</b>
                        </li>
                        <li>
                            {t("point4.part1")} <b>{t("point4.bold")}</b>
                        </li>
                        <li>
                            {t("point5.part1")} <b>{t("point5.bold1")}</b> {t("point5.and")} <b>{t("point5.bold2")}</b> {t("point5.part2")}
                        </li>
                        <li>
                            {t("point6.part1")} <b>{t("point6.bold")}</b> {t("point6.part2")}
                        </li>
                        <li>
                            {t("point7.part1")} <b>{t("point7.bold")}</b> {t("point7.part2")}
                        </li>
                        <li>
                            {t("point8.part1")} <b>{t("point8.bold")}</b> {t("point8.part2")}
                        </li>
                        <li>
                            {t("point9.part1")} <b>{t("point9.bold")}</b> {t("point9.part2")}
                        </li>
                        <li>
                            {t("point10.part1")} <b>{t("point10.bold")}</b> {t("point10.part2")}
                        </li>
                    </ul>
                </div>
            </section>
        </>
    );
};

export default ResponsibleAI;
